import api from "../apiClient";

// Jobs (trades ontology) — single source for the endpoint family.
// Backend contract: crm_backend/jobs_app (mounted at /api/jobs/) and
// appointments_app for visits. Every caller imports these functions; the URL
// literal exists in exactly ONE place (proposed-actions rule).

export const JOBS_ENDPOINT = "/jobs/";

export const listJobs = (params = {}) => api.get(JOBS_ENDPOINT, { params });

export const getJob = (jobId) => api.get(`${JOBS_ENDPOINT}${jobId}/`);

export const updateJob = (jobId, payload = {}) =>
  api.patch(`${JOBS_ENDPOINT}${jobId}/`, payload);

export const completeJob = (jobId) =>
  api.post(`${JOBS_ENDPOINT}${jobId}/complete/`, {});

export const listJobMaterials = (jobId) =>
  api.get(`${JOBS_ENDPOINT}${jobId}/materials/`);

export const addJobMaterial = (jobId, payload = {}) =>
  api.post(`${JOBS_ENDPOINT}${jobId}/materials/`, payload);

export const updateJobMaterial = (jobId, materialId, payload = {}) =>
  api.patch(`${JOBS_ENDPOINT}${jobId}/materials/${materialId}/`, payload);

export const deleteJobMaterial = (jobId, materialId) =>
  api.delete(`${JOBS_ENDPOINT}${jobId}/materials/${materialId}/`);

// Visits are Appointments carrying job=<id> — appointmentsApi is the single
// source for that endpoint family; these are named passthroughs.
export {
  createAppointment as createJobVisit,
  updateAppointment as updateJobVisit,
  deleteAppointment as deleteJobVisit,
} from "./appointmentsApi";

// Job-scoped photos (StoredFile.job).
export const listJobFiles = (jobId) =>
  api.get("/storage/files/", { params: { job: jobId } });

// Team roster for the assignee picker (same primary endpoint Settings uses).
export const listTeamMembers = () => api.get("/accounts/team/");
